import { Component } from '@angular/core';
import { EmptyStateComponent } from '../shared/ui/empty-state/empty-state.component';

@Component({
  selector: 'app-service-unavailable',
  imports: [
    EmptyStateComponent,
  ],
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
})
export class ServiceUnavailableComponent {

  protected async reloadApp(): Promise<void> {
    window.location.reload();
  }
}
